import { render, staticRenderFns } from "./Pop.vue?vue&type=template&id=9c4c7da8&scoped=true"
import script from "./Pop.vue?vue&type=script&lang=ts"
export * from "./Pop.vue?vue&type=script&lang=ts"
import style0 from "./Pop.vue?vue&type=style&index=0&id=9c4c7da8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4c7da8",
  null
  
)

export default component.exports